import React, { Component } from 'react'
import Select from "react-select";
import * as JobOptions from '../../../../Function/defaultJobOptions'

class Carrier extends Component {
    constructor() {
        super()
    }
    render() {

        const { jobData, formValidator } = this.props

        if (!jobData || Object.keys(jobData).length === 0) return false

        return (
            <div className="card">
                <div className="card-header bg-light"><h4>Carrier Information</h4></div>
                <div className="card-body">

                    <div className="row">
                        <div className="mb-3 col-md-4 col-12">
                            <div className="mb-3">
                                <label className="form-label">M Awb /M B/L</label>
                                <input
                                    className="form-control form-control-sm"
                                    name="m_awb_m_b_l"
                                    value={jobData.m_awb_m_b_l}
                                    onChange={(e) => this.props.onChangeValue(e, 'carrier_details')}
                                />
                                {
                                    // formValidator.message('M Awb /M B/L', jobData.m_awb_m_b_l, 'required', { className: 'text-danger' })
                                }
                            </div>

                            <div className="mb-3">
                                <label className="form-label">H Awb / H B/L</label>
                                <input
                                    className="form-control form-control-sm"
                                    name="m_awb_h_b_l"
                                    value={jobData.m_awb_h_b_l}
                                    onChange={(e) => this.props.onChangeValue(e, 'carrier_details')}
                                />
                                {
                                    // formValidator.message('H Awb / H B/L', jobData.m_awb_h_b_l, 'required', { className: 'text-danger' })
                                }
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Expected Delivery Date</label>
                                <input
                                type='date'
                                    className="form-control form-control-sm"
                                    name="expected_delivery_date"
                                    value={jobData.expected_delivery_date}
                                    onChange={(e) => this.props.onChangeValue(e, 'carrier_details')}
                                />

                            </div>

                        </div>

                        <div className="mb-3 col-md-4 col-12">
                            <div className="mb-3">
                                <label className="form-label">Carrier Name</label>
                                <input
                                    className="form-control form-control-sm"
                                    name="carrier_name"
                                    value={jobData.carrier_name}
                                    onChange={(e) => this.props.onChangeValue(e, 'carrier_details')}
                                />
                                {
                                    // formValidator.message('carrier name', jobData.carrier_name, 'required', { className: 'text-danger' })
                                }
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Port of Entry</label>
                                <input
                                    className="form-control form-control-sm"
                                    name="port_of_entry"
                                    value={jobData.port_of_entry}
                                    onChange={(e) => this.props.onChangeValue(e, 'carrier_details')}
                                />
                                {
                                    // formValidator.message('port of entry', jobData.port_of_entry, 'required', { className: 'text-danger' })
                                }
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Destiation Vendor</label>
                                <input
                                    className="form-control form-control-sm"
                                    name="destination_vendor"
                                    value={jobData.destination_vendor}
                                    onChange={(e) => this.props.onChangeValue(e, 'carrier_details')}
                                />
                                {
                                    // formValidator.message('carrier name', jobData.destination_vendor, 'required', { className: 'text-danger' })
                                }
                            </div>

                        </div>
                        <div className="mb-3 col-md-4 col-12">

                            <div className="mb-3">
                                <label className="form-label">Port of Loading</label>
                                <input
                                    className="form-control form-control-sm"
                                    name="port_of_loading"
                                    value={jobData.port_of_loading}
                                    onChange={(e) => this.props.onChangeValue(e, 'carrier_details')}
                                />

                            </div>
                            <div className="mb-3">
                                <label className="form-label">Port of Discharge</label>
                                <input
                                    className="form-control form-control-sm"
                                    name="port_of_discharge"
                                    value={jobData.port_of_discharge}
                                    onChange={(e) => this.props.onChangeValue(e, 'carrier_details')}
                                />

                            </div>
                            

                        </div>

                        {/* <div className="mb-3 col-md-4 col-12">
                            <div className="mb-3">
                                <label className="form-label">Shipment Type</label>
                                <Select
                                    options={JobOptions.shipmentType()}
                                    name="shipment_type"
                                    value={JobOptions.shipmentType().filter(obj => obj.value === jobData.shipment_type)}
                                    onChange={(e)=>this.props.onChangeValue(e, 'carrier_details','shipment_type')}
                                />
                                {
                                    // formValidator.message('shipment type', jobData.shipment_type, 'required', { className: 'text-danger' })
                                }
                            </div>
                        </div> */}

                        <div className="col-12">
                            <div className="">
                                <label className="form-label">Comment</label>
                                <textarea
                                    className="form-control form-control-sm"
                                    name="comments"
                                    value={jobData.comments}
                                    onChange={(e) => this.props.onChangeValue(e, 'carrier_details')}

                                />
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        )
    }
}

export default Carrier